"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
var _customerOrderApi = require("@/api/customerOrderApi");
var _shopIntegralApi = require("@/api/shopIntegralApi");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var defaultForm = function defaultForm() {
  return {
    receivedTimeType: 1,
    receivedDelayDays: '0',
    refundCustomerOrNot: true,
    refundPlatformOrNot: true,
    mallDisplayEnabled: true,
    mallCustomerScope: 0,
    mallCustomerIds: [],
    expiredOrNot: false,
    expiredDay: 1,
    expiryReminderEnabled: false,
    expiryReminderLeadDays: 7,
    expiryReminderMergeDays: 7,
    integralRuleContent: ''
  };
};
var _default = exports.default = {
  name: 'IntegralSystemConfig',
  components: {
    Tinymce: _Tinymce.default
  },
  data: function data() {
    return {
      pageLoading: false,
      submitLoading: false,
      customerLoading: false,
      customerOptions: [],
      form: defaultForm()
    };
  },
  created: function created() {
    this.initPage();
  },
  methods: {
    initPage: function () {
      var _initPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.pageLoading = true;
              _context.p = 1;
              _context.n = 2;
              return Promise.all([this.loadConfig(), this.searchCustomerOptions('')]);
            case 2:
              _context.p = 2;
              this.pageLoading = false;
              return _context.f(2);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[1,, 2, 3]]);
      }));
      function initPage() {
        return _initPage.apply(this, arguments);
      }
      return initPage;
    }(),
    toBool: function toBool(v, defaultValue) {
      if (v == null) return defaultValue;
      if (typeof v === 'boolean') return v;
      if (v === 1 || v === '1') return true;
      if (v === 0 || v === '0') return false;
      return !!v;
    },
    applyConfigToForm: function applyConfigToForm(data) {
      if (!data || _typeof(data) !== 'object') {
        this.form = defaultForm();
        return;
      }
      var f = defaultForm();
      if (data.receivedTimeType != null) f.receivedTimeType = Number(data.receivedTimeType);
      if (data.receivedDelayDays != null) f.receivedDelayDays = String(data.receivedDelayDays);
      f.refundCustomerOrNot = this.toBool(data.refundCustomerOrNot, true);
      f.refundPlatformOrNot = this.toBool(data.refundPlatformOrNot, true);
      f.mallDisplayEnabled = this.toBool(data.mallDisplayEnabled, true);
      f.mallCustomerScope = Number(data.mallCustomerScope) === 1 ? 1 : 0;
      f.mallCustomerIds = Array.isArray(data.mallCustomerIds) ? data.mallCustomerIds.map(Number).filter(function (id) {
        return Number.isInteger(id) && id > 0;
      }) : [];
      f.expiredOrNot = this.toBool(data.expiredOrNot, false);
      f.expiredDay = data.expiredDay != null ? Number(data.expiredDay) : 1;
      f.expiryReminderEnabled = this.toBool(data.expiryReminderEnabled, false);
      f.expiryReminderLeadDays = data.expiryReminderLeadDays != null ? Number(data.expiryReminderLeadDays) : 7;
      f.expiryReminderMergeDays = data.expiryReminderMergeDays != null ? Number(data.expiryReminderMergeDays) : 7;
      f.integralRuleContent = data.integralRuleContent || '';
      this.form = f;
    },
    loadConfig: function () {
      var _loadConfig = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return (0, _shopIntegralApi.shopIntegralIntegralGetConfigApi)();
            case 1:
              data = _context2.v;
              this.applyConfigToForm(data);
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t = _context2.v;
              this.form = defaultForm();
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function loadConfig() {
        return _loadConfig.apply(this, arguments);
      }
      return loadConfig;
    }(),
    searchCustomerOptions: function () {
      var _searchCustomerOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(keyword) {
        var data, oldMap, nextList;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.customerLoading = true;
              _context3.p = 1;
              _context3.n = 2;
              return (0, _customerOrderApi.companyappAutoListApi)({
                keyword: keyword || ''
              });
            case 2:
              data = _context3.v;
              oldMap = new Map((this.customerOptions || []).map(function (item) {
                return [Number(item.customerId), item];
              }));
              nextList = Array.isArray(data) ? data : [];
              nextList.forEach(function (item) {
                var customerId = Number(item.customerId);
                if (Number.isInteger(customerId) && customerId > 0) {
                  oldMap.set(customerId, _objectSpread(_objectSpread({}, item), {}, {
                    customerId: customerId
                  }));
                }
              });
              this.customerOptions = Array.from(oldMap.values());
            case 3:
              _context3.p = 3;
              this.customerLoading = false;
              return _context3.f(3);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[1,, 3, 4]]);
      }));
      function searchCustomerOptions(_x) {
        return _searchCustomerOptions.apply(this, arguments);
      }
      return searchCustomerOptions;
    }(),
    customerOptionLabel: function customerOptionLabel(item) {
      var appName = item.appName || item.customerName || "\u5BA2\u6237 ".concat(item.customerId);
      return item.customerName && item.customerName !== appName ? "".concat(appName, "\uFF08").concat(item.customerName, "\uFF09") : appName;
    },
    onReceivedDelayDaysInput: function onReceivedDelayDaysInput(value) {
      var normalized = String(value == null ? '' : value).replace(/\D/g, '').slice(0, 10);
      if (normalized !== value) {
        this.form.receivedDelayDays = normalized;
      }
    },
    validateForm: function validateForm() {
      if (!/^\d{1,10}$/.test(this.form.receivedDelayDays)) {
        this.$message.warning('积分到账天数请输入0或最多10位的非负整数');
        return false;
      }
      if (this.form.mallDisplayEnabled && this.form.mallCustomerScope === 1 && (!Array.isArray(this.form.mallCustomerIds) || !this.form.mallCustomerIds.length)) {
        this.$message.warning('请选择关联小程序客户');
        return false;
      }
      if (this.form.expiredOrNot) {
        var expiredDay = Number(this.form.expiredDay);
        if (!Number.isInteger(expiredDay) || expiredDay < 1) {
          this.$message.warning('请填写有效的积分有效天数');
          return false;
        }
      }
      var leadDays = Number(this.form.expiryReminderLeadDays);
      var mergeDays = Number(this.form.expiryReminderMergeDays);
      if (!Number.isInteger(leadDays) || leadDays < 0 || leadDays > 365) {
        this.$message.warning('提前提醒天数请输入0至365的整数');
        return false;
      }
      if (!Number.isInteger(mergeDays) || mergeDays < 0 || mergeDays > 365) {
        this.$message.warning('合并时间窗请输入0至365的整数');
        return false;
      }
      return true;
    },
    buildSubmitBody: function buildSubmitBody() {
      var f = this.form;
      return {
        receivedTimeType: Number(f.receivedTimeType),
        receivedDelayDays: Number(f.receivedDelayDays),
        refundCustomerOrNot: !!f.refundCustomerOrNot,
        refundPlatformOrNot: !!f.refundPlatformOrNot,
        mallDisplayEnabled: !!f.mallDisplayEnabled,
        mallCustomerScope: Number(f.mallCustomerScope) === 1 ? 1 : 0,
        mallCustomerIds: f.mallDisplayEnabled && Number(f.mallCustomerScope) === 1 ? _toConsumableArray(new Set(f.mallCustomerIds.map(Number))) : [],
        expiredOrNot: !!f.expiredOrNot,
        expiredDay: f.expiredOrNot ? Number(f.expiredDay) : null,
        expiryReminderEnabled: !!f.expiryReminderEnabled,
        expiryReminderLeadDays: Number(f.expiryReminderLeadDays),
        expiryReminderMergeDays: Number(f.expiryReminderMergeDays),
        integralRuleContent: f.integralRuleContent || ''
      };
    },
    handleConfirm: function () {
      var _handleConfirm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (this.validateForm()) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              this.submitLoading = true;
              _context4.p = 2;
              _context4.n = 3;
              return (0, _shopIntegralApi.shopIntegralIntegralConfigApi)(this.buildSubmitBody());
            case 3:
              this.$message.success('设置成功');
              _context4.n = 4;
              return this.loadConfig();
            case 4:
              _context4.p = 4;
              this.submitLoading = false;
              return _context4.f(4);
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this, [[2,, 4, 5]]);
      }));
      function handleConfirm() {
        return _handleConfirm.apply(this, arguments);
      }
      return handleConfirm;
    }()
  }
};